export const partnershipsData = {
  intro:
    "Voitech Solutions forms strategic partnerships with internationally renowned brands to offer top-quality products and solutions. These collaborations keep us at the forefront of technology and best practices in ICT and Audio-Visual sectors.",

  description:
    "By leveraging the expertise and resources of our partners, we enhance our service offerings to ensure clients benefit from proven, reliable technologies backed by global support networks.",

  partners: [
    { name: "TOA", logo: "/img/partners/toa.png", category: "Audio" },

    // If you don't have yamaha.png yet, either add it or keep this as a placeholder.

    { name: "AVer", logo: "/img/partners/aver.png", category: "AV" },
    { name: "Televic", logo: "/img/partners/televic.png", category: "Conference" },
    { name: "NEUTRIK", logo: "/img/partners/neutrik.png", category: "Connectors" },

    // Your file is named "ubiquity.png" (not ubiquiti.png)
    { name: "UBIQUITI", logo: "/img/partners/ubiquity.png", category: "Networking" },

    { name: "Kramer", logo: "/img/partners/kramer.png", category: "AV" },
    { name: "SOPHOS", logo: "/img/partners/sophos.png", category: "Security" },


    { name: "Mitel", logo: "/img/partners/mitel.png", category: "UC" },
    { name: "Ruijie", logo: "/img/partners/ruijie.png", category: "Networking" },
    { name: "Microsoft", logo: "/img/partners/microsoft.png", category: "Software" },
    { name: "ZeeVee", logo: "/img/partners/zeevee.png", category: "AV" },
    { name: "Grandstream", logo: "/img/partners/grandstream.png", category: "UC" },
    { name: "FLUKE Networks", logo: "/img/partners/fluke.png", category: "Testing" },
    { name: "GIGANET", logo: "/img/partners/giganet.png", category: "Cabling" },
    { name: "SIEMON", logo: "/img/partners/siemon.png", category: "Cabling" },
    { name: "TELTONIKA", logo: "/img/partners/teltonika.png", category: "IoT" },
    { name: "Check Point", logo: "/img/partners/checkpoint.png", category: "Security" },
  ],
};
